<template>
  <div class="wrapper">
    <!--个人信息-->
    <div class="top">
      <van-row class="bg"></van-row>
      <div class="infobox">
        <div class="infobox-top">
          <van-row class="infomid">
            <van-row type="flex" align="center" justify="space-between">
              <img class="setting" src="./../../assets/images/information/setting.png" alt=""
                @click="linkTo('setting')" />
              <img v-if="isLogin == 0" style="border: 0; background: #fff"
                src="./../../assets/images/information/morentouxiang.png" class="pic" alt="" />
              <img v-else :src="info.head_pic" alt class="pic" @click="linkTo('setting')" />
              <!-- <div class="signbox" v-if="isLogin==0">
                <span>请点击登录</span>
              </div> -->
              <div class="nbr-content2">
                <van-row class="nick" @click.native="copy" data-clipboard-action="copy"
                  :data-clipboard-text="userInfo.nbr" style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  ">
                  <div class="name sigle-h">
                    {{ info.nick_name || "" }}
                  </div>
                </van-row>
                <van-row class="ID" @click.native="copy" data-clipboard-action="copy"
                  :data-clipboard-text="userInfo.nbr">ID:{{ userInfo.nbr
                  }}<img src="./../../assets/images/information/copy.png" alt="" /></van-row>
                <!-- <van-row class="time">消费金额: ￥{{info.total_shopping_amount||'0.00'}}</van-row> -->
                <!-- <van-row class="time" style="margin-top:.02rem">注册时间: {{info.create_time||''}}</van-row> -->
              </div>
            </van-row>
          </van-row>
        </div>
        <div class="infobox-bottom">
          <div class="bottomItem" @click="linkTo('coupon')">
            <span class="key">{{ info.couple_num || "0" }}张</span>
            <span>优惠券</span>
          </div>
          <div class="bottomItem" @click="linkTo('recharge')">
            <span class="key">{{ info.balance || "0.00" }}</span>
            <span>我的余额</span>
          </div>
        </div>
        <!--我的订单-->
        <div class="mid">
          <van-row @click.native="linkTo('myorder?index=0')" type="flex" align="center" justify="space-between"
            class="title">
            <van-col class="name">我的订单</van-col>
            <van-col class="mid-order"> 查看全部订单 > </van-col>
          </van-row>
          <van-row type="flex" align="center" justify="center" class="order-details">
            <van-row @click.native="linkTo('myorder?index=1')" class="fiveequal">
              <div class="tag" v-if="orderNumInfo.unpaid_no > 0">
                {{ orderNumInfo.unpaid_no }}
              </div>
              <img src="./../../assets/images/information/Payment.png" alt />
              <span>待付款</span>
            </van-row>
            <van-row @click.native="linkTo('myorder?index=2')" class="fiveequal">
              <div class="tag" v-if="orderNumInfo.paid_no > 0">
                {{ orderNumInfo.paid_no }}
              </div>
              <img src="./../../assets/images/information/shipped.png" alt />
              <span>待发货</span>
            </van-row>
            <van-row @click.native="linkTo('myorder?index=3')" class="fiveequal">
              <div class="tag" v-if="orderNumInfo.deliver_no > 0">
                {{ orderNumInfo.deliver_no }}
              </div>
              <img src="./../../assets/images/information/received.png" alt />
              <span>待收货</span>
            </van-row>
            <van-row @click.native="linkTo('myorder?index=4')" class="fiveequal">
              <div class="tag" v-if="orderNumInfo.uncomment_no > 0">
                {{ orderNumInfo.uncomment_no }}
              </div>
              <img src="./../../assets/images/information/evaluated.png" alt />
              <span>评价</span>
            </van-row>
            <van-row @click.native="linkTo('replacementlist')" class="fiveequal">
              <div class="tag" v-if="orderNumInfo.refund_no > 0">
                {{ orderNumInfo.refund_no }}
              </div>
              <img src="./../../assets/images/information/Refund_and_refund.png" alt />
              <span>售后</span>
            </van-row>
          </van-row>
        </div>
      </div>
    </div>
    <!--我的服务-->

    <div class="newsBanner" @click="linkTo('news')" v-if="newsObj.state == '0'">
      <img :src="newsObj.banner_path" alt="" />
    </div>

    <div class="mid" style="margin-top: 0.23rem">
      <van-row type="flex" align="center" class="title" style="border-bottom: 1px solid #f2f2f2">
        <van-col class="name">我的服务</van-col>
      </van-row>
      <van-row style="padding: 0 0.29rem 0.38rem">
        <van-col span="8" v-if="userInfo.nbr" class="threeequal" @click.native="showup">
          <img class="img" src="./../../assets/images/information/service.png" alt />
          <span>联系客服</span>
        </van-col>
        <van-col @click.native="linkTo('coupon')" span="8" class="threeequal">
          <img class="img" src="./../../assets/images/information/Coupon.png" alt />
          <span>优惠券</span>
        </van-col>
        <van-col @click.native="linkTo('addresslist')" span="8" class="threeequal">
          <img class="img" src="./../../assets/images/information/Management.png" alt />
          <span>收货地址</span>
        </van-col>
        <van-col @click.native="linkTo('collect')" span="8" class="threeequal">
          <img class="img" src="./../../assets/images/information/collection.png" alt />
          <span>收藏夹</span>
        </van-col>
        <!-- <van-col @click.native="linkTo('giftCard')" span="8" class="threeequal">
          <img
            class="img"
            src="./../../assets/images/information/giftCard.png"
            alt
          />
          <span>礼品卡兑换</span>
        </van-col> -->
        <van-col v-if="showCard" @click.native="linkTo('myEquity')" span="8" class="threeequal">
          <img class="img" src="./../../assets/images/information/myEquity.png" alt />
          <span>权益卡</span>
        </van-col>

        <!-- <van-col span="8" class="threeequal">
          <img class="img" src="./../../assets/images/information/shopConfig.png" alt />
          <span>店铺设置</span>
        </van-col>
         -->
        <van-col @click.native="linkTo('fingerpost')" span="8" class="threeequal">
          <img class="img" src="./../../assets/images/information/fingerpost.png" alt />
          <span>新手指南</span>
        </van-col>
      </van-row>
    </div>
    <!--<div class="logOut" @click="ShowlogOut">-->
    <!--<span>退出登录</span>-->
    <!--</div>-->
    <!-- <a class="bottomTextNotice" href="tel:0571-85788595">
      <span class="text1">杭州联虹网络科技有限公司提供技术支持</span>
      <span class="text2">获取技术支持请致电 0571-85788595</span>
    </a> -->
    <div class="line2"></div>
    <!--退出登录弹窗-->
    <van-popup v-model="logShow" :close-on-click-overlay="false">
      <van-row class="popup1">
        <van-row class="content1" type="flex" justify="center" align="center">确认退出登录吗？</van-row>
        <van-row>
          <van-col class="cancel1" @click.native="logShow = false">取消</van-col>
          <van-col class="confirm1" @click.native.stop="logOut">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <van-popup v-model="show1" style="border-radius: 0.2rem">
      <div class="servicebox">
        <img class="serviceimg" @click="show1 = false" src="./../../assets/images/information/Close.svg" alt />
        <div class="servicespan">
          <p class="wechat">有米日记服务中心</p>
          <span>有米日记售后系统上线啦！</span>
          <span>长按识别小程序码，即可体验全新售后体验</span>
          <!--<span>菜单底部直接联系客服</span>-->
        </div>
        <div class="codeimg">
          <img src="./../../assets/images/xcx_qrcode.jpg" alt />
        </div>
      </div>
    </van-popup>

    <van-popup v-model="pickPayShow" style="border-radius: 0.24rem">
      <div class="reminder">
        <img class="reminderimg" src="./../../assets/images/ii.png" alt />
        <p class="reminderTitle">支付提醒</p>
        <p class="reminderDesc">
          用户您好，您有售后订单快递费用还未支付，为不影响后续售后请尽快支付。
        </p>
        <div class="reminderBtn" @click.stop="linkTo('replacementlist')">
          <span>前往支付</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import "./../../assets/js/tool";
  import { mapMutations } from "vuex";
  import weChatShareApi from "../../assets/js/weChatShare";

  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    computed: {},
    data() {
      return {
        info: {},
        supWxId: "",
        orderNumInfo: {},
        show: false,
        show1: false,
        pickPayShow: false,
        scroll: 0,
        isLogin: 0,
        sysValue: 1,
        userPhone: "",
        is_support_mine_chat: 0,
        is_support_logout: 0,
        logShow: false,
        newsObj: {},
        showCard: false,
      };
    },
    watch: {
      phoneNo(newval, oldval) {
        if (newval.length > 11) {
          this.phoneNo = oldval;
        } else {
          this.phoneNo = newval;
        }
      },
      code(newval, oldval) {
        if (newval.length > 6) {
          this.code = oldval;
        } else {
          this.code = newval;
        }
      },
    },
    methods: {
      ...mapMutations({
        senduserInfo: "SENDuserInfo",
      }),
      copy() {
        let nbtn = new this.$clipboard(".nick");
        let cbtn = new this.$clipboard(".ID");
        nbtn.on("success", (e) => {
          this.$toast({
            message: "已复制ID",
            duration: 2000,
          });
        });
        nbtn.on("error", (e) => {
          this.$toast({
            message: "复制失败",
            duration: 2000,
          });
        });
        cbtn.on("success", (e) => {
          this.$toast({
            message: "已复制ID",
            duration: 2000,
          });
        });
        cbtn.on("error", (e) => {
          this.$toast({
            message: "复制失败",
            duration: 2000,
          });
        });
      },
      closePhone() {
        this.phoneShow = false;
        this.phoneNo = "";
        this.code = "";
      },
      ShowlogOut() {
        this.logShow = true;
      },
      logOut() {
        this.info = {};
        let option = {
          title: "我的店铺",
          desc: "欢迎光临我的店铺",
          link: location.origin,
          images: this.cdnImgPath + "/images/default/wx_head_default.jpg",
        };
        this.isLogin = 0;
        this.weChatShare(option);
        this.logShow = false;
        this.orderNumInfo = false;
        this.sysValue = 1;
        this.userPhone = "";
        let userInfo = {
          nbr: "",
        };
        this.senduserInfo(userInfo);
        window.scrollTo(0, 0);
        localStorage.removeItem("openid");
        localStorage.removeItem("unionid");
        localStorage.removeItem("is_new_coupon");
      },
      linkTo(url) {
        this.$router.push({
          path: "/" + url,
          query: { supNbr: this.userInfo.nbr },
        });
      },
      initPage() {
        let that = this;
        that.is_support_mine_chat = localStorage.getItem("otherConfig_10011");
        that.is_support_logout = localStorage.getItem("otherConfig_10012");
        let option = {
          title: "有米@" + this.userInfo.name + "的店铺",
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl,
        };
        this.isLogin = 1;
        this.weChatShare(option);
        this.getdata();
        // 订单数量
        this.$commonPost({
          jydm: "flow_30023",
          flow_30023: {
            user_nbr: this.userInfo.nbr,
          },
        })
          .then((resp) => {
            this.orderNumInfo = resp;
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      },
      showup() {
        // this.show1 = true;
        let url = `https://kefu.kjyoumi.com/api/mobileweb/home?channel_id=34483&channel_key=34483zkeq&wechatapp_id=345097&key=76967s450&openid=${this.userInfo.nbr}&nickName=${encodeURIComponent(this.info.nick_name)}&avatarUrl=${encodeURIComponent(this.info.head_pic)}&mobile=${this.info.phone_no || ''}`
        let u = navigator.userAgent
        let isandroid = u.indexOf('android') > -1 || u.indexOf('adr') > -1;
        if (isandroid) url = url + '&isvivo=1'
        // window.open(url)
        this.$router.push({
          path: "/iframe",
          query: {
            title: encodeURIComponent('在线客服'),
            url: encodeURIComponent(url),
          },
        });
      },
      noShopKeeper() {
        this.$toast({
          message: "您当前无粉丝！",
          duration: 2000,
        });
      },
      getSupUser() {
        if (this.userInfo && this.userInfo.nbr) {
          this.$commonPost({
            jydm: "flow_10062",
            flow_10062: {
              user_nbr: this.userInfo.nbr,
            },
          })
            .then((resp) => {
              this.supWxId = resp.agent_wx_id || "";
            })
            .catch((err) => { });
        }
      },
      getdata() {
        // 用户数据
        this.$commonPost({
          jydm: "flow_10003",
          flow_10003: {
            user_nbr: this.userInfo.nbr,
          },
        })
          .then((resp) => {
            resp.integral = parseInt(resp.integral);
            resp.create_time = resp.create_time.substring(0, 10);
            this.info = resp;
            this.userPhone = resp.phone_no || "";
            if (parseFloat(resp.unpay_num || "0") > 0) this.pickPayShow = true;
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
        this.getSupUser();
        this.$commonPost({
          jydm: "flow_10056",
          flow_10056: {
            value: 1,
          },
        })
          .then((response) => {
            this.sysValue = response.sys_value;
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });

        this.$commonPost({
          jydm: "flow_160004",
          flow_160004: {
            nbr: "1",
          },
        })
          .then((response) => {
            this.newsObj = response;
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });

        this.$commonPost({
          jydm: "flow_10107",
          flow_10107: {
            user_nbr: this.userInfo.nbr,
          },
        })
          .then((response) => {
            this.showCard = response.state == '2';
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      },
    },
    // 被缓存时任执行
    activated() {
      document.title = "我的";
      window.scrollTo(0, this.scroll);
      this.initPage();
    },
    created() { },
    mounted() { },
    beforeRouteLeave(to, from, next) {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      next();
    },
  };
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
  .phoneCotainer {
    width: 6rem;
    height: 7.2rem;
    background: #fff;
    border-radius: 0.16rem;
    box-sizing: border-box;
    padding-top: 0.92rem;
    position: relative;

    .close {
      width: 0.4rem;
      height: 0.4rem;
      position: absolute;
      right: 0.2rem;
      top: 0.2rem;
    }

    .title {
      font-size: 0.36rem;
      font-weight: bold;
      color: #333;
      text-align: center;
      line-height: 0.5rem;
      margin-bottom: 0.6rem;
    }

    .inputItem {
      width: 5.36rem;
      height: 0.98rem;
      border-bottom: 0.02rem solid #e5e5e5;
      margin: 0.2rem auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      img {
        width: 0.36rem;
        height: 0.36rem;
        margin-left: 0.2rem;
      }

      input {
        border: none;
        width: 50%;
        height: 0.98rem;
        color: #1a1a1a;
        font-size: 0.3rem;
        font-weight: 400;
        margin-left: 0.25rem;
        margin-right: 0.25rem;

        &::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #ccc;
          font-size: 0.3rem;
        }

        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #ccc;
          font-size: 0.3rem;
        }

        &:-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #ccc;
          font-size: 0.3rem;
        }
      }

      .codeBtn {
        color: #e52b25;
        font-size: 0.3rem;
        font-weight: 500;
        margin-right: 0.1rem;
        height: 0.98rem;
        line-height: 0.98rem;
      }

      .time {
        margin-left: 0.1rem;
        margin-right: 0.1rem;
        color: #999;
        font-size: 0.3rem;
        font-weight: 500;
        width: 1.5rem;
        height: 0.98rem;
        line-height: 0.98rem;
        display: inline-block;
        text-align: center;
      }
    }

    .ok {
      margin: 1rem auto 0;
      background: #e52b25;
      border-radius: 0.5rem;
      width: 4.84rem;
      height: 0.88rem;
      line-height: 0.88rem;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 0.3rem;
        font-weight: bold;
        color: #fff;
        line-height: 0;
      }
    }
  }

  .popup1 {
    width: 6.14rem;
    height: 3.04rem;

    .content1 {
      font-weight: 400;
      height: 1.96rem;
      text-align: center;
      font-size: 0.3rem;
      color: #333333;
      border-bottom: 1px solid #eeeeee;
    }

    .cancel1 {
      height: 1.07rem;
      text-align: center;
      line-height: 1.07rem;
      width: 50%;
      font-weight: 500;
      font-size: 0.3rem;
      color: #333333;
      border-right: 1px solid #eeeeee;
    }

    .confirm1 {
      height: 1.07rem;
      text-align: center;
      line-height: 1.07rem;
      width: 50%;
      font-size: 0.3rem;
      font-weight: 500;
      color: #e52b25;
    }
  }

  .logOut {
    margin: 0.4rem auto;
    background: #e52b25;
    width: 90%;
    height: 1rem;
    border-radius: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0.02rem 0.1rem 0 rgba(0, 0, 0, 0.11);

    span {
      font-size: 0.3rem;
      color: #fff;
      font-weight: 600;
    }
  }

  .recommender {
    width: 6.9rem;
    height: 0.58rem;
    background: #f9f9f9;
    border-radius: 0.08rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.75rem;
    font-size: 0.28rem;
    color: #000000;
    font-weight: 500;
    padding-left: 0.14rem;
    padding-right: 0.2rem;

    span {
      width: 5.5rem;
      height: 0.58rem;
      line-height: 0.58rem;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .call {
    border: 1px solid #e52b25;
    border-radius: 0.04rem;
    display: flex;
    justify-content: center;
    height: 0.36rem;
    width: 0.84rem;
    text-align: center;

    span {
      margin-top: 0.06rem;
      font-size: 0.2rem;
      color: #e52b25;
      height: 0.24rem;
      line-height: 0.24rem;
    }
  }

  .call.grey {
    span {
      color: #ccc !important;
    }

    border-color: #ccc;
  }

  .userPhone {
    width: calc(100% - 0.48rem);
    padding: 0 0.24rem;
    margin-top: 0.25rem;
    padding-top: 0.25rem;
    height: 0.54rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 0.2rem solid #f8f9fb;

    .key {
      font-size: 0.28rem;
      color: #333;
      font-weight: bold;
    }

    .value {
      font-weight: 500;
      font-size: 0.28rem;
      color: #999;
    }
  }

  .servicebox {
    width: 6.14rem;
    height: 7.66rem;
    background: #ffffff;
    box-shadow: 0 0.02rem 0.34rem 0 rgba(239, 51, 66, 0.12);

    .serviceimg {
      width: 0.4rem;
      height: 0.4rem;
      position: absolute;
      top: 0.2rem;
      right: 0.2rem;
    }

    .servicespan {
      padding-top: 0.75rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 0.26rem;
      color: #999;
      text-align: center;
      margin-bottom: 0.62rem;

      span {
        line-height: 0.4rem;
      }

      .wechat {
        font-size: 0.4rem;
        color: #000000;
        font-weight: bold;
        margin-bottom: 0.1rem;
        line-height: 0.56rem;
      }
    }

    .codeimg {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 4rem;
        height: 4rem;
      }
    }
  }

  /*绑定邀请人*/
  .van-popup {
    border-radius: 0.16rem;

    .popup {
      width: 6rem;
      height: 7rem;
      box-sizing: border-box;
      position: relative;
      background: #e7ebf1;
      display: flex;
      flex-direction: column;

      .imgx {
        position: absolute;
        top: 0.16rem;
        right: 0.16rem;
        width: 0.32rem;
        height: 0.32rem;
      }

      .title {
        font-weight: bold;
        font-size: 0.36rem;
        color: #22269c;
        margin-top: 0.26rem;
        line-height: 0.5rem;
      }

      .imgbox {
        img {
          width: 6rem;
          height: 3.44rem;
        }
      }

      .content {
        width: 4.8rem;
        height: 0.88rem;
        text-align: center;
        font-size: 0.28rem;
        color: #999999;
        margin: 0 auto;
        background: #f7f7f7;
        border-radius: 0.5rem;
        border: 1px solid #cdd4dd;

        input {
          width: 80%;
          height: 80%;
          border: none;
          background: transparent;
          color: #333333;
        }
      }

      .content input::-webkit-input-placeholder {
        color: #bbbbbb;
      }
    }

    .bottom {
      display: flex;
      justify-content: center;
      margin-top: 0.38rem;
    }

    .confirm {
      height: 0.8rem;
      text-align: center;
      line-height: 0.8rem;
      width: 4.8rem;
      font-size: 0.32rem;
      border-radius: 0.5rem;
      border-right: 1px solid #ebebeb;
      background: #e52b25;
      color: #ffffff;
      box-shadow: 0 0.04rem 0.04rem 0 rgba(0, 0, 0, 0.3);
    }
  }

  .wrapper {
    width: 100%;
    /* background: #f5f5f5; */
    margin-bottom: 1rem;
    /*padding-bottom:1rem;*/
    background: #f8f9fb;
    min-height: calc(100vh - 1rem);
  }

  .top {
    .bg {
      height: 4.44rem;
      width: 100%;
      background: url(./../../assets/images/information/infoBg.png) no-repeat;
      background-size: 100%;
    }

    .infobox {
      height: auto;
      margin-top: -4.44rem;
      margin-bottom: 0.2rem;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .infobox-top {
        width: 100%;
        height: 1.9rem;
      }

      .infobox-bottom {
        display: flex;
        flex-direction: row;
        width: 100%;

        .bottomItem {
          flex: 1;
          height: 1.2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          line-height: 0.33rem;

          span {
            color: #fff;
            font-weight: 500;
            font-size: 0.24rem;
            line-height: 0.42rem;
          }

          .key {
            font-size: 0.3rem;
            font-weight: bold;
          }
        }
      }

      .pic {
        width: 1rem;
        height: 1rem;
        position: absolute;
        top: 0.58rem;
        left: 0.3rem;
        border-radius: 50%;
      }

      .signbox {
        position: absolute;
        top: 0.7rem;
        left: 2.3rem;
        border: 1px solid #ffffff;
        width: 1.92rem;
        height: 0.74rem;
        border-radius: 0.37rem;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          font-size: 0.3rem;
          color: #ffffff;
        }
      }

      .nbr-content {
        position: relative;
        left: 2.3rem;
        top: 0.4rem;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        height: 1.56rem;
      }

      .nbr-content2 {
        position: absolute;
        left: 1.48rem;
        top: 0.6rem;
        display: flex;
        flex-direction: column;
        height: 1.56rem;
      }

      .infomid {
        line-height: 0.28rem;
        font-size: 0.2rem;
        font-weight: 500;
        color: #fff;

        .name {
          font-size: 0.28rem;
          font-weight: 500;
          line-height: 0.4rem;
          max-width: 4.5rem;
          display: inline-block;
        }

        .role {
          width: 1.8rem;
          height: 0.48rem;
          background: #2c0b05;
          border-radius: 0.24rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 0.24rem;
          transform: scale(0.5);
          transform-origin: left;

          img {
            width: 0.36rem;
            height: 0.32rem;
            margin-right: 0.12rem;
          }

          span {
            font-size: 0.32rem;
            font-weight: 500;
            color: #caa565;
            line-height: 0.48rem;
          }
        }

        .ID {
          margin-bottom: 0.06rem;
          display: flex;
          align-items: center;

          img {
            width: 0.16rem;
            height: 0.18rem;
            margin-left: 0.16rem;
          }
        }

        .type {
          font-weight: 500;
          background: #fff;
          border-top-left-radius: 0.4rem;
          border-bottom-left-radius: 0.4rem;
          font-size: 0.48rem;
          color: #e52b25;
          height: 0.88rem;
          text-indent: 0.4rem;
          top: 0.84rem;
          right: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transform: scale(0.5);
          transform-origin: 100%;
          position: absolute;

          img {
            width: 0.48rem;
            height: 0.48rem;
            color: #5045d8;
            background: #ffffff;
            margin-left: 0.12rem;
            margin-right: 0.18rem;
          }
        }

        .time {
          font-size: 0.2rem;
          color: #fff;
          font-weight: 500;
          line-height: 0.28rem;
        }
      }

      .graybg {
        flex: 1;
        height: 0.96rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        span {
          font-size: 0.32rem;
          color: #000000;
          line-height: 0.44rem;
          font-weight: 500;
        }

        div {
          max-width: 5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 0.32rem;
          color: #000000;
          line-height: 0.44rem;
          font-weight: 500;
        }
      }
    }
  }

  .mid {
    background-color: #ffffff;
    width: 6.9rem;
    border-radius: 0.2rem;
    margin: 0 auto;

    .order-details {
      justify-content: space-evenly;
      box-sizing: border-box;
      padding-bottom: 0.26rem;
    }

    .title {
      height: 0.82rem;
      padding: 0 0.26rem;
      font-size: 0.24rem;
      color: #333333;
      font-weight: 500;

      .circle {
        margin-left: 0;
      }

      .name {
        line-height: 0.33rem;
        font-weight: bold;
        margin-left: 0.04rem;
      }

      .mid-order {
        font-size: 0.4rem;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: scale(0.5);
        transform-origin: 100% 50%;
      }
    }

    /*5等分*/
    .fiveequal {
      width: 1.38rem;
      height: 0.92rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;

      img {
        width: 0.46rem;
        height: 0.46rem;
        margin-bottom: 0.06rem;
      }

      span {
        font-weight: 500;
        font-size: 0.2rem;
        color: #333333;
        line-height: 0.28rem;
      }

      .tag {
        min-width: 0.6rem;
        height: 0.6rem;
        position: absolute;
        right: 0.4rem;
        line-height: 0.6rem;
        top: 0;
        color: #fff;
        font-size: 0.48rem;
        font-weight: 500;
        text-align: center;
        box-sizing: border-box;
        border-radius: 0.64rem;
        background: #fe0e4b;
        transform: translateX(50%);
        transform-origin: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 0.12rem;
        transform: scale(0.5);
        transform-origin: 145% 0;
      }
    }

    .fiveequal-s {
      width: 2.16rem;
      height: 2.6rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-right: 0.27rem;
      background: #ffffff;
      box-shadow: 0 0 0.08rem 0 rgba(0, 0, 0, 0.12);
      border-radius: 0.08rem;

      &:last-child {
        margin-right: 0;
      }

      .buttonbox {
        width: 1rem;
        height: 0.32rem;
        border: 1px solid #e52b25;
        border-radius: 0.16rem;
        position: relative;
        margin-top: 0.12rem;

        span {
          font-weight: 500;
          font-size: 0.4rem;
          color: #e52b25;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(0.5);
        }
      }

      .nonbr {
        border: 1px solid #cccccc !important;

        span {
          color: #cccccc !important;
        }
      }

      img {
        width: 0.72rem;
        height: 0.72rem;
        margin-bottom: 0.16rem;
      }

      span {
        font-weight: 700;
        font-size: 0.28rem;
        color: #333333;
      }

      p {
        font-family: 500;
        font-size: 0.22rem;
        color: #999999;
        text-align: center;
        margin-top: 0.04rem;
        line-height: 0.34rem;

        i {
          font-family: 500;
          font-size: 0.22rem;
          color: #e52b25;
        }
      }
    }

    a:last-child .fiveequal-s {
      margin-right: 0;
    }


    .equal {
      height: 1.24rem;
      padding: 0 0.28rem;

      img {
        width: 0.76rem;
        height: 0.76rem;
      }

      div {
        font-size: 0.24rem;
        color: #333333;
        line-height: 0.34rem;
      }

      span {
        font-size: 0.2rem;
        color: #999999;
        line-height: 0.28rem;

        .red {
          color: #e52b25;
        }
      }

      .van-col {
        height: 100%;
        line-height: 0.44rem;
      }

      .van-row {
        height: 100%;
      }
    }

    .marginleft {
      margin-left: 0.6rem;
    }

    .marginright {
      margin-right: 0.6rem;
    }

    .flex {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .moneylist {
      height: 0.96rem;
      background: #ffffff;
      box-shadow: 0 0 0.24rem 0 rgba(215, 215, 215, 0.5);
      padding: 0 0.28rem;
      box-sizing: border-box;
      font-size: 0.24rem;
      color: #999999;
      line-height: 0.96rem;

      span {
        font-size: 0.28rem;
        color: #333333;
      }
    }

    .threeequal {
      width: 1.58rem;
      height: 1.12rem;
      margin-top: 0.18rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 0.24rem;
      color: #333333;
      line-height: 0.33rem;

      img {
        width: 0.44rem;
        height: 0.44rem;
        margin-bottom: 0.06rem;
      }

      .img {
        width: 0.44rem;
        height: 0.44rem;
        margin-bottom: 0.06rem;
      }
    }
  }

  .line {
    width: 100%;
    height: 0.24rem;
    background: #f8f9fb;
  }

  .line2 {
    width: 100%;
    height: 0.6rem;
    background: #f8f9fb;
  }

  .blackBg {
    width: 1.7rem;
    height: 0.24rem;
    position: absolute;
    left: 0.32rem;
    background: #000;
    border-radius: 0.07rem;
    margin-top: -0.08rem;
  }

  .myzc {
    background: #fff;
    width: 7.02rem;
    height: 2.18rem;
    box-shadow: 0 0 0.08rem 0 rgba(0, 0, 0, 0.12);
    border-radius: 0.08rem;
    margin: 0 auto 0.24rem;
    position: relative;
    z-index: 3;

    .titleText {
      width: 1.63rem;
      height: 0.44rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3f3e3a;
      border-radius: 0.03rem 0.03rem 0.2rem 0.2rem;
      position: absolute;
      left: 0.08rem;
      top: -0.08rem;

      span {
        font-weight: 500;
        font-size: 0.56rem;
        color: #ffeea4;
        transform: scale(0.5);
        white-space: nowrap;
      }
    }

    img {
      width: 2.66rem;
      height: 1.72rem;
      position: absolute;
      right: 0.25rem;
      bottom: 0;
    }

    .myyj {
      position: absolute;
      left: 0.18rem;
      bottom: 0.7rem;

      span {
        font-size: 0.3rem;
        color: #333;
        font-weight: 500;
      }

      .number {
        font-size: 0.7rem;
      }
    }

    .btn {
      width: 1.28rem;
      height: 0.4rem;
      background: #e52b25;
      border-radius: 0.22rem;
      position: absolute;
      left: 0.25rem;
      bottom: 0.11rem;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 0.6rem;
        color: #ffffff;
        font-weight: 500;
        transform: scale(0.5);
        white-space: nowrap;
      }
    }
  }

  .home-tomorrow-c::-webkit-scrollbar {
    display: none;
  }

  .home-tomorrow {
    white-space: nowrap;
  }

  .home-tomorrow-cm {
    position: relative;
    display: inline-block;
    height: 3rem;
  }

  .bottomTextNotice {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 0.5rem;

    span {
      font-weight: 400;
      color: #999;
    }

    .text1 {
      font-size: 0.26rem;
      line-height: 0.37rem;
    }

    .text2 {
      margin-top: 0.14rem;
      line-height: 0.33rem;
      font-size: 0.24rem;
    }
  }

  .setting {
    position: absolute;
    width: 0.4rem;
    height: 0.4rem;
    top: 0.58rem;
    right: 0.3rem;
  }

  .newsBanner {
    width: 6.9rem;
    margin: 0.2rem auto 0;

    img {
      display: block;
      width: 6.9rem;
    }
  }

  .reminder {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 6.1rem;
    background: #fff;
    box-sizing: border-box;
    padding-top: 0.5rem;

    .reminderimg {
      width: 0.62rem;
      height: 0.62rem;
    }

    .reminderTitle {
      margin-top: 0.2rem;
      height: 0.45rem;
      line-height: 0.45rem;
      color: #333;
      font-size: 0.32rem;
      font-weight: bold;
    }

    .reminderDesc {
      width: 4.43rem;
      line-height: 0.44rem;
      color: #999;
      font-size: 0.28rem;
      text-align: center;
      margin: 0.24rem 0 0.3rem;
    }

    .reminderBtn {
      width: 100%;
      height: 0.85rem;
      border-top: 1px solid #e6e9ed;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      span {
        color: #ff3d3d;
        font-size: 0.28rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/information/information.vue